var map = {
	"./1-AX-.png": 65717,
	"./2-AX.png": 68307,
	"./3-AX.png": 17450,
	"./4-AX.png": 48421,
	"./5-AX.png": 90428,
	"components/Catalog/AX/img/allDoor/Gold/1-AX-.png": 65717,
	"components/Catalog/AX/img/allDoor/Gold/2-AX.png": 68307,
	"components/Catalog/AX/img/allDoor/Gold/3-AX.png": 17450,
	"components/Catalog/AX/img/allDoor/Gold/4-AX.png": 48421,
	"components/Catalog/AX/img/allDoor/Gold/5-AX.png": 90428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89314;